import { render, staticRenderFns } from "./chooseSubject.vue?vue&type=template&id=44af09aa&"
import script from "@viewJs/examRegisteation/chooseSubject.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/chooseSubject.js?vue&type=script&lang=js&"
import style0 from "./chooseSubject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports